
import { WorldCountry } from '../types';

export const russiaData: WorldCountry = {
  code: 'RU',
  name: 'Russia',
  slug: 'russia',
  population: 146171015,
  topCities: [
    { name: 'Moscow', slug: 'moscow', population: 12506468 },
    { name: 'Saint Petersburg', slug: 'saint-petersburg', population: 5384342 },
    { name: 'Novosibirsk', slug: 'novosibirsk', population: 1625631 },
    { name: 'Yekaterinburg', slug: 'yekaterinburg', population: 1493749 },
    { name: 'Kazan', slug: 'kazan', population: 1257391 },
    { name: 'Nizhny Novgorod', slug: 'nizhny-novgorod', population: 1252236 },
    { name: 'Chelyabinsk', slug: 'chelyabinsk', population: 1196680 },
    { name: 'Samara', slug: 'samara', population: 1156644 },
    { name: 'Omsk', slug: 'omsk', population: 1154116 },
    { name: 'Rostov-on-Don', slug: 'rostov-on-don', population: 1137904 },
    { name: 'Ufa', slug: 'ufa', population: 1125933 },
    { name: 'Krasnoyarsk', slug: 'krasnoyarsk', population: 1093771 },
    { name: 'Perm', slug: 'perm', population: 1055397 },
    { name: 'Voronezh', slug: 'voronezh', population: 1054537 },
    { name: 'Volgograd', slug: 'volgograd', population: 1008998 },
    { name: 'Krasnodar', slug: 'krasnodar', population: 932629 },
    { name: 'Saratov', slug: 'saratov', population: 901361 },
    { name: 'Tyumen', slug: 'tyumen', population: 847488 },
    { name: 'Tolyatti', slug: 'tolyatti', population: 699367 },
    { name: 'Izhevsk', slug: 'izhevsk', population: 648944 },
    { name: 'Barnaul', slug: 'barnaul', population: 632372 },
    { name: 'Ulyanovsk', slug: 'ulyanovsk', population: 627705 },
    { name: 'Irkutsk', slug: 'irkutsk', population: 623562 },
    { name: 'Khabarovsk', slug: 'khabarovsk', population: 616372 },
    { name: 'Yaroslavl', slug: 'yaroslavl', population: 608353 },
    { name: 'Vladivostok', slug: 'vladivostok', population: 606589 },
    { name: 'Makhachkala', slug: 'makhachkala', population: 601286 },
    { name: 'Tomsk', slug: 'tomsk', population: 575352 },
    { name: 'Orenburg', slug: 'orenburg', population: 572188 },
    { name: 'Kemerovo', slug: 'kemerovo', population: 552105 },
    { name: 'Ryazan', slug: 'ryazan', population: 539290 },
    { name: 'Naberezhnye Chelny', slug: 'naberezhnye-chelny', population: 533839 },
    { name: 'Astrakhan', slug: 'astrakhan', population: 529793 },
    { name: 'Penza', slug: 'penza', population: 520300 },
    { name: 'Lipetsk', slug: 'lipetsk', population: 508887 },
    { name: 'Tula', slug: 'tula', population: 475161 },
    { name: 'Kirov', slug: 'kirov', population: 507155 },
    { name: 'Cheboksary', slug: 'cheboksary', population: 497618 },
    { name: 'Kaliningrad', slug: 'kaliningrad', population: 489359 },
    { name: 'Bryansk', slug: 'bryansk', population: 405150 },
    { name: 'Kursk', slug: 'kursk', population: 440052 },
    { name: 'Ivanovo', slug: 'ivanovo', population: 404344 },
    { name: 'Magnitogorsk', slug: 'magnitogorsk', population: 413351 },
    { name: 'Tver', slug: 'tver', population: 425072 },
    { name: 'Stavropol', slug: 'stavropol', population: 433931 },
    { name: 'Nizhniy Tagil', slug: 'nizhniy-tagil', population: 356044 },
    { name: 'Belgorod', slug: 'belgorod', population: 391554 },
    { name: 'Arkhangelsk', slug: 'arkhangelsk', population: 348343 },
    { name: 'Vladimir', slug: 'vladimir', population: 349951 },
    { name: 'Sochi', slug: 'sochi', population: 443562 },
    { name: 'Kurgan', slug: 'kurgan', population: 310911 },
    { name: 'Smolensk', slug: 'smolensk', population: 326863 },
    { name: 'Kaluga', slug: 'kaluga', population: 336726 },
    { name: 'Chita', slug: 'chita', population: 324444 },
    { name: 'Orel', slug: 'orel', population: 310838 },
    { name: 'Volzhskiy', slug: 'volzhskiy', population: 323293 },
    { name: 'Cherepovets', slug: 'cherepovets', population: 315738 },
    { name: 'Saransk', slug: 'saransk', population: 314394 },
    { name: 'Vologda', slug: 'vologda', population: 311657 },
    { name: 'Tambov', slug: 'tambov', population: 290933 },
    { name: 'Yoshkar-Ola', slug: 'yoshkar-ola', population: 279604 },
    { name: 'Komsomolsk-on-Amur', slug: 'komsomolsk-on-amur', population: 263906 },
    { name: 'Taganrog', slug: 'taganrog', population: 250312 },
    { name: 'Kostroma', slug: 'kostroma', population: 268742 },
    { name: 'Murmansk', slug: 'murmansk', population: 295374 },
    { name: 'Novorossiysk', slug: 'novorossiysk', population: 274608 },
    { name: 'Yakutsk', slug: 'yakutsk', population: 355443 },
    { name: 'Grozny', slug: 'grozny', population: 328533 },
    { name: 'Dzerzhinsk', slug: 'dzerzhinsk', population: 233126 },
    { name: 'Syktyvkar', slug: 'syktyvkar', population: 243873 },
    { name: 'Nizhnevartovsk', slug: 'nizhnevartovsk', population: 277668 },
    { name: 'Novy Urengoy', slug: 'novy-urengoy', population: 118188 },
    { name: 'Shakhty', slug: 'shakhty', population: 235608 },
    { name: 'Nizhnekamsk', slug: 'nizhnekamsk', population: 236609 },
    { name: 'Khimki', slug: 'khimki', population: 259550 },
    { name: 'Mytishchi', slug: 'mytishchi', population: 222852 },
    { name: 'Balashikha', slug: 'balashikha', population: 507366 },
    { name: 'Royalty', slug: 'royalty', population: 197559 },
    { name: 'Podolsk', slug: 'podolsk', population: 215311 },
    { name: 'Lyubertsy', slug: 'lyubertsy', population: 203798 },
    { name: 'Elektrostal', slug: 'elektrostal', population: 158652 },
    { name: 'Kolomna', slug: 'kolomna', population: 144589 },
    { name: 'Serpukhov', slug: 'serpukhov', population: 126822 },
    { name: 'Odintsovo', slug: 'odintsovo', population: 141134 },
    { name: 'Orekhovo-Zuevo', slug: 'orekhovo-zuevo', population: 120670 },
    { name: 'Noginsk', slug: 'noginsk', population: 101765 },
    { name: 'Sergiev Posad', slug: 'sergiev-posad', population: 104372 },
    { name: 'Shchelkovo', slug: 'shchelkovo', population: 128497 },
    { name: 'Zhukovsky', slug: 'zhukovsky', population: 107589 },
    { name: 'Pushkino', slug: 'pushkino', population: 110739 },
    { name: 'Ramenskoye', slug: 'ramenskoye', population: 118924 },
    { name: 'Dolgoprudny', slug: 'dolgoprudny', population: 115672 },
    { name: 'Vidnoye', slug: 'vidnoye', population: 74843 },
    { name: 'Reutov', slug: 'reutov', population: 107911 },
    { name: 'Lobnya', slug: 'lobnya', population: 84754 },
    { name: 'Lyubertsy', slug: 'lyubertsy-2', population: 203798 },
    { name: 'Korolev', slug: 'korolev', population: 225668 },
    { name: 'Fryazino', slug: 'fryazino', population: 58921 },
    { name: 'Ivanteevka', slug: 'ivanteevka', population: 77598 },
    { name: 'Klimovsk', slug: 'klimovsk', population: 56756 },
    { name: 'Krasnoznamensk', slug: 'krasnoznamensk', population: 40081 },
    { name: 'Bronnitsy', slug: 'bronnitsy', population: 22789 },
    { name: 'Volokolamsk', slug: 'volokolamsk', population: 19492 },
    { name: 'Yegoryevsk', slug: 'yegoryevsk', population: 69967 },
    { name: 'Kashira', slug: 'kashira', population: 42692 }
  ]
};
